import { useState } from 'react';
import { MOCK_USERS } from '../../assets/mockData';
import { useUser } from '../../contexts/UserContext';

function getUserName(userId, currentUser) {
  if (userId === 'currentUser' || userId === currentUser.id) return currentUser.name;
  return MOCK_USERS.find((u) => u.id === userId)?.name || '未知用户';
}

function timeAgo(ts) {
  const diff = Date.now() - ts;
  if (diff < 60000) return '刚刚';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`;
  return `${Math.floor(diff / 86400000)}天前`;
}

export default function CommentSection({ comments, visible, onAddComment }) {
  const [text, setText] = useState('');
  const { user } = useUser();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    onAddComment(text.trim());
    setText('');
  };

  return (
    <div className={`comment-section ${visible ? 'comment-visible' : 'comment-hidden'}`}>
      <div className="comment-list">
        {comments.map((c) => (
          <div key={c.id} className="comment-item">
            <span className="comment-author">{getUserName(c.userId, user)}</span>
            <span className="comment-text">{c.content}</span>
            <span className="comment-time">{timeAgo(c.time)}</span>
          </div>
        ))}
        {comments.length === 0 && (
          <div className="comment-empty">暂无评论，来说点什么吧</div>
        )}
      </div>
      <form className="comment-form" onSubmit={handleSubmit}>
        <input
          type="text"
          className="comment-input"
          placeholder="写下你的评论..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <button type="submit" className="comment-submit" disabled={!text.trim()}>
          发送
        </button>
      </form>
    </div>
  );
}
